import { getAccessTokenFromLocal } from "../helpers";
import { API_URL } from "../../Store/Shared/Middleware/API/Constants";

export class ApiService {
  private static instance: ApiService;

  private constructor() { }

  public static getInstance(): ApiService {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }

  private isDevelopmentMode(): boolean {
    return process.env.NODE_ENV === 'development';
  }


  private getHeaders(data?: any): HeadersInit {
    const headers: HeadersInit = {};

    // FormData ise Content-Type header'ını ekleme
    if (!(data instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    // Auth0 bypass kontrolü
    const token: any = localStorage.getItem(window.btoa('accessToken'));
    if (token) {
      const accessToken = window.atob(token);
      headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return headers;
  }

  private async request<T>(url: string, options: RequestInit, data?: any): Promise<T> {
    const fullUrl = `${API_URL}${url}`;
    const headers = this.getHeaders(data);

    try {
      const response = await fetch(fullUrl, {
        ...options,
        headers,
        body: data instanceof FormData ? data : (data ? JSON.stringify(data) : undefined),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ API Error Response:', {
          status: response.status,
          statusText: response.statusText,
          url: fullUrl,
          error: errorText
        });
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('💥 API Request Failed:', {
        url: fullUrl,
        method: options.method,
        error: error
      });
      throw error;
    }
  }

  async get<T>(url: string): Promise<T> {
    return this.request<T>(url, {
      method: 'GET',
    });
  }

  async post<T>(url: string, data?: any): Promise<T> {
    try {
      console.log('🌐 ApiService: POST request', { url, dataType: typeof data });
      
      const response = await this.request<T>(url, {
        method: 'POST',
      }, data);
      
      console.log('🌐 ApiService: POST response', { 
        url, 
        data: response 
      });
      
      return response;
    } catch (error) {
      console.error('❌ ApiService: POST error', { url, error });
      throw error;
    }
  }

  async put<T>(url: string, data?: any): Promise<T> {
    return this.request<T>(url, {
      method: 'PUT',
    }, data);
  }

  async delete<T>(url: string): Promise<T> {
    return this.request<T>(url, {
      method: 'DELETE',
    });
  }

  async patch<T>(url: string, data?: any): Promise<T> {
    return this.request<T>(url, {
      method: 'PATCH',
    }, data);
  }
} 